export const backendUrl : string  = process.env.REACT_APP_BACKEND_URL || "http://localhost:8080";
export const frontendUrl : string  = process.env.REACT_APP_FRONTEND_URL || "http://localhost:3000";